module.exports = __webpack_public_path__ + "img/wind.243d3fb4.svg";